import styled from 'styled-components';

export const CollapseWrapper = styled.div`
  border-radius: 8px;

  h4 {
    font-size: 12px;
    display: flex;
    gap: 5px;

    span {
      width: max-content;
    }

    @media (max-width: 370px) {
      flex-direction: column;
    }
  }

  button {
    padding: 4px;
    font-size: 12x;
    margin-top: 20px;
  }

  @media (max-width: 600px) {
    .container-buttons {
      flex-direction: column;
      align-items: normal;
    }
  }
`;
